<template>
  <!-- A desktop browser renders a PDF in an iframe natively, with its own
       toolbar, text selection and search. Nothing to improve on there. -->
  <iframe
    v-if="useNativeViewer"
    :src="file.signed_url"
    class="full-width full-height no-border bg-grey-4"
  />

  <!-- The app hands the file to the phone: Quick Look on iOS, the PDF app on
       Android. Those have text selection, search and real zoom, which the
       canvas viewer below only approximates. The viewer opens as soon as the
       file is known, and its Done returns here, where the file itself is
       managed: details, download, delete. This block is what that return
       lands on, and the way back into the document. -->
  <div
    v-else-if="$q.platform.is.nativeMobile"
    class="column items-center text-center q-pa-lg"
  >
    <q-icon
      name="mdi-file-pdf-box"
      size="4em"
      color="red-4"
    />
    <div class="text-subtitle1 q-mt-sm break-word">
      {{ file.file_name }}
    </div>
    <div class="text-caption text-grey-5">
      Opens in your phone's PDF viewer
    </div>
    <q-btn
      class="q-mt-md"
      color="white"
      text-color="black"
      unelevated
      no-caps
      icon-right="mdi-open-in-new"
      label="Open PDF"
      :loading="opening"
      @click="openNatively"
    />
  </div>

  <!-- Mobile Safari will not display a PDF inline, so this used to offer a
       button out to the browser instead. PdfPreview draws the pages to a
       canvas, which behaves the same everywhere, so the document can simply be
       read here. Its own failure state still offers the file. -->
  <PdfPreview
    v-else
    :src="file.signed_url"
    fill
    @open-externally="(url) => goToHref(url)"
  />
</template>

<script>
import { openPdfNatively } from 'src/helpers/nativeFile'

import fileMixin from './mixin'
import PdfPreview from 'components/partials/PdfPreview'

export default {
  components: { PdfPreview },
  mixins: [fileMixin],
  data () {
    return {
      opening: false
    }
  },
  computed: {
    useNativeViewer () {
      return this.$q.screen.width >= 600 &&
        !this.$q.platform.is.mobile &&
        !this.$q.platform.is.nativeMobile
    }
  },
  methods: {
    async openNatively () {
      this.opening = true
      const name = this.file.file_name.replace(/[/\\]/g, '_')
      await openPdfNatively(
        this.file.signed_url,
        `files/${this.file.id}/${/\.pdf$/i.test(name) ? name : name + '.pdf'}`
      )
      this.opening = false
    }
  },
  mounted () {
    if (this.$q.platform.is.nativeMobile) {
      this.openNatively()
    }
  }
}
</script>
